const AccordionScrollInit = () => {
  // When an accordion pane opens while another (possibly very long) pane
  // closes, the page height shrinks and the browser keeps the old scroll
  // offset, leaving the accordion far outside the viewport. After the
  // opening transition finished, bring the item back into view right
  // below the fixed header.
  document.addEventListener("shown.bs.collapse", (event) => {
    const pane = event.target;

    if (!pane.classList.contains("accordion-collapse")) {
      return;
    }

    const item = pane.closest(".accordion-item");

    if (!item) {
      return;
    }

    const fixedHeader = document.querySelector(".navbar.fixed-top");
    const headerHeight = fixedHeader
      ? fixedHeader.getBoundingClientRect().height
      : 0;
    const offset = headerHeight + 8;
    const itemTop = item.getBoundingClientRect().top;

    const isBehindHeader = itemTop < offset;
    const isBelowViewport = itemTop > window.innerHeight;

    if (isBehindHeader || isBelowViewport) {
      window.scrollTo({
        top: itemTop + window.scrollY - offset,
        behavior: "smooth",
      });
    }
  });
};

export default AccordionScrollInit;
